import saveUploadedFieldShapeSlice from './saveUploadedFieldShapeSlice';

const fieldsSlices = [saveUploadedFieldShapeSlice];

export default fieldsSlices;
